import { fetchWithoutToken } from '../utils/fetch';

export const getInfoUserD2L = async (codeParam, institutionCode) => {
	const getCredentials = (code) => {
		switch (code) {
			case 'PCI':
				return {
					client_id: process.env.REACT_APP_CLIENTID_PCI,
					client_secret: process.env.REACT_APP_CLIENTSECRET_PCI,
					base_url: 'https://learn.pcihealth.edu',
					redirect_uri: 'https://pci-library.aquinasnetwork.tech/d2l-callback',
				};
			default:
				return {
					client_id: '',
					client_secret: '',
					base_url: '',
					redirect_uri: '',
				};
		}
	};

	try {
		const credentials = getCredentials(institutionCode);
		const res = await fetchWithoutToken.post(
			`/d2l`,
			{
				client_id: credentials.client_id,
				client_secret: credentials.client_secret,
				code: codeParam,
				base_url: credentials.base_url,
				redirect_uri: credentials.redirect_uri,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			},
		);
		return res;
	} catch (error) {
		console.error(
			'Your authorization token has expired or is incorrect.',
			error,
		);
		return null;
	}
};
